import React from 'react';
import PropTypes from 'prop-types';
import { Badge } from 'react-bootstrap';
import { PROGRAM_NAMES } from '@/shared/utils/deadline';
import { PROGRAM_PAGE_URLS } from '@/shared/utils/programInfo';

/**
 * The one sentence every page uses for a program that is switched off this
 * term, linking to the program's own MSU Denver page. Pages decide when to
 * show it from the program's isActive switch; none words it themselves.
 */
export function ProgramComingSoonText({ programType, id, className }) {
    return (
        <span id={id} className={className}>
            Not accepting applications through the Peer Support Hub this term.
            Visit the{' '}
            <a
                href={PROGRAM_PAGE_URLS[programType]}
                target="_blank"
                rel="noopener noreferrer"
                // Pages render this inside clickable program cards; opening
                // the program's page must not also select or deselect it.
                onClick={(e) => e.stopPropagation()}
            >
                {PROGRAM_NAMES[programType]} program page
                <span className="visually-hidden"> (opens in a new tab)</span>
            </a>{' '}
            for more information.
        </span>
    );
}

ProgramComingSoonText.propTypes = {
    programType: PropTypes.oneOf(['la', 'si', 'ta']).isRequired,
    id: PropTypes.string,
    className: PropTypes.string,
};

/** The sentence with a "Coming soon" badge ahead of it. */
function ProgramComingSoon({ programType, id, className = '' }) {
    return (
        <div className={className}>
            <Badge bg="secondary" className="me-2">
                Coming soon
            </Badge>
            <ProgramComingSoonText
                programType={programType}
                id={id}
                className="small"
            />
        </div>
    );
}

ProgramComingSoon.propTypes = {
    programType: PropTypes.oneOf(['la', 'si', 'ta']).isRequired,
    id: PropTypes.string,
    className: PropTypes.string,
};

export default ProgramComingSoon;
